// extracted by mini-css-extract-plugin
export default {"cls1":"Oe8u1yKaC64lfH_7j9kQ","cls2":"BdWqt9oyO2B6CTIuZMqH Oe8u1yKaC64lfH_7j9kQ"};